import { DateTime } from "luxon";
import type { AnnieAvatarSettings } from "../../../utils/annieStream";
import { useOneTimeNotice } from "../../UIToolkit/molecules/OneTimeNotice";

const STUDIO_NUDGE_KEY = "annie_studio_nudge";
const STUDIO_NUDGE_EXPIRES_AT = DateTime.fromISO("2027-03-31T23:59:59", { zone: "utc" });

/** The opening screen's "make Annie yours" invitation. */
export interface AnnieStudioNudge {
	isVisible: boolean;
	/** Marks it seen, so it never returns. Opening the Studio from anywhere calls this too. */
	dismiss: () => void;
}

/** Shown once, only to someone who has neither designed Annie nor turned her off. */
export const useAnnieStudioNudge = (settings: AnnieAvatarSettings | undefined): AnnieStudioNudge => {
	const notice = useOneTimeNotice(STUDIO_NUDGE_KEY, { expiresAt: STUDIO_NUDGE_EXPIRES_AT });
	const hasNeverCustomized = settings !== undefined && settings.avatar === null && !settings.hidden;
	return { isVisible: notice.isEligible && hasNeverCustomized, dismiss: notice.dismiss };
};
